import React from "react";

export const Sandbox: React.FC = () => {
  return <div className="flex size-full flex-col gap-4"></div>;
};
